import styled from '@emotion/styled';
import React from 'react';

interface InspectorRowProps {
  label: string;
  children: React.ReactNode;
  highlight?: boolean;
}

const InspectorRow: React.FC<InspectorRowProps> = ({ label, children, highlight = false }) => (
  <Root>
    <Label highlight={highlight}>{label}</Label>
    <Control highlight={highlight}>{children}</Control>
  </Root>
);

export default InspectorRow;

const Root = styled.div`
  display: grid;
  grid-template-columns: 104px 1fr;
  align-items: center;
  gap: 8px;
  font-size: 13px;
`;

const Label = styled.span<{ highlight: boolean }>`
  min-width: 0;
  overflow-wrap: break-word;
  color: ${(p) => (p.highlight ? '#dc2626' : '#6b7280')};
  font-weight: ${(p) => (p.highlight ? 600 : 'normal')};
`;

const Control = styled.div<{ highlight: boolean }>`
  display: flex;
  min-width: 0;
  border-left: 2px solid ${(p) => (p.highlight ? '#dc2626' : 'transparent')};
  padding-left: ${(p) => (p.highlight ? '6px' : '0')};
`;
